<template>
  <header>
    <img v-responsive.xl src="@/assets/images/banners/banner-cursos-home-1680x1050.jpg" alt="" class="w-100">
    <img v-responsive.lg.md src="@/assets/images/banners/banner-cursos-home-1024x768.jpg" alt="" class="w-100">
    <img v-responsive.sm src="@/assets/images/banners/banner-cursos-home-768x1024.jpg" alt="" class="w-100">
    <img v-responsive.xs src="@/assets/images/banners/banner-cursos-home-500x750.jpg" alt="" class="w-100">
    <div class="hyper-link">
      <div class="content">
        <a href="#/cursos"  class="btn btn-lg shadow b-orange auto-ajust-font mx-2 px-5">
          Buscar cursos
        </a>
      </div>
    </div>
  </header>
</template>
<style scoped lang="scss">

  .content {
    text-align: center;
    float: right;
    @media only screen and (min-width: 500px) {
      width: 68vw;
    }
    @media only screen and (min-width: 544px) {
      width: 63vw;
    }
    @media only screen and (min-width: 767px) {
      width: 48vw;
    }
    @media only screen and (min-width: 1200px) {
      width: 43vw;
    }
  }

  /**
    hyper-link:
   */
  .hyper-link {
    position: absolute;
    width: 100%;
    right: 0;

    @media only screen and (min-width: 500px) {
      top: 50vw;
      .auto-ajust-font{
        font-size: 3.7vw;
      }
    }
    @media only screen and (min-width: 544px) {
      top: 45vw;
      .auto-ajust-font{
        font-size: 2.5vw;
      }
    }
    @media only screen and (min-width: 767px) {
      top: 40vw;
      .auto-ajust-font{
        font-size: 1.8vw;
      }
    }
    @media only screen and (min-width: 1200px) {
      top: 35vw;
      .auto-ajust-font{
        font-size: 1.5vw;
      }
    }
  }

  /**
    header and backgroundImage
   */
  header{
    width: 100%;
    height: 100%;
    @media only screen and (min-width: 992px) {
      height: 100vh;
      overflow: hidden;
    }
    img{
      width: 100%;
    }
  }

</style>
<script>
  export default {
    computed: {
      isLogin: function () {
        return this.$store.getters.isLoggedIn
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/#public/home/slider/Courses.vue